import { LoaderCircle } from "lucide-react";
import styles from './LoadingSpinner.module.css';

function LoadingSpinner({color="white"}) {

    return (
        <LoaderCircle className={styles.spinner} color={color} />
    )
}

export default LoadingSpinner;